import { render, staticRenderFns } from "./messageDetails.vue?vue&type=template&id=386ce6b2&scoped=true"
import script from "./messageDetails.vue?vue&type=script&lang=js"
export * from "./messageDetails.vue?vue&type=script&lang=js"
import style0 from "./messageDetails.vue?vue&type=style&index=0&id=386ce6b2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386ce6b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('386ce6b2')) {
      api.createRecord('386ce6b2', component.options)
    } else {
      api.reload('386ce6b2', component.options)
    }
    module.hot.accept("./messageDetails.vue?vue&type=template&id=386ce6b2&scoped=true", function () {
      api.rerender('386ce6b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/news/components/messageDetails.vue"
export default component.exports